import { render } from "./ValidationCode.vue?vue&type=template&id=13112834"
import script from "./ValidationCode.vue?vue&type=script&lang=js"
export * from "./ValidationCode.vue?vue&type=script&lang=js"
script.render = render

export default script